<template>
  <div class="page">
    <div class="topLayout">
      <div class="navLayout">
        <div class="titleLayout">选择成员</div>
        <button @click="closePage()">x</button>
      </div>
      <yd-search v-model="keyword" :on-submit="submitHandler" :on-cancel="cancelHandle"></yd-search>
    </div>    
    <ul class="userListLayout" v-if="userArray && userArray.length>0">
      <div v-for="(person, index) in userArray" :key="index">
        <li>
          <div class="personCellLayout">
            <div class="personCellPortrait">
              <img :src="person.img_path|cutFitWidthImg('90w_90h')">  
            </div>
            <div class="personNameLayout">
              <p>{{person.nickname}}</p>
              <p v-if="person.loginName && person.loginName.length < 15">{{person.loginName}}</p>
            </div >
            <div class="personSelectedLayout">
              <button @click="selectUserAction(person)">添加</button>
            </div>
          </div>
          <div class="singleLineLayout"></div>
        </li>
      </div>
      <li class="loadMoreButtonLayout" @click="loadMore">
    		<span>{{loadMoreText}}</span>
    	</li>
    </ul>
    <div v-else style="height:calc(100vh - 100px);background-color:white"></div>
  </div>
</template>

<script>
import appService from "@/services/request/appService"
import { cutFitWidthImg } from "@/services/libs/utils"
import store from 'store'
export default {
  name:"UserList",
  data() {
    return {
      mine:{},
      userArray: [],
      keyword:'',
      pageNo:1,
      selectedUser:{},
      noMoreData: false,
    }
  },
  computed: {
    loadMoreText: function () {
	  		return this.noMoreDataText ? '没有更多数据了' : '点击加载更多'
	  }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.mine = store.get('mine')
      this.loadData()
      window.addEventListener('scroll',this.scroll)
    })
  },
  beforeDestroy: function() {
		window.removeEventListener('scroll', this.scroll)
	},
  methods: {
    loadData(callback) {
      appService
      .getUserList({
        iid: this.mine.iid,
        unionId: this.mine.unionId,
        queryKey: this.keyword,
        pageNumber: this.pageNo,
        pageSize: 20,
      })
      .then(data => {
        if(this.pageNo == 1) {
          this.userArray = []
        }
        if(data && data.length) {
          this.userArray.push.apply(this.userArray, data)
          this.pageNo++
          this.noMoreData = false
        }else {
          this.noMoreData = true
          if(typeof callback === 'function') callback()
        }
      })
    },
    submitHandler() {
      this.pageNo = 1
      this.loadData(() => {
        this.$dialog.toast({
          mes: '未找到相关用户',
          timeout: 1500
        });
      })
    },
    cancelHandle() {
      this.keyword = ''
      this.pageNo = 1
      this.loadData()
    },
    scroll() {
			if(document.body.scrollTop + window.innerHeight >= document.body.offsetHeight) {
					this.loadData()
			}
		},
    closePage() {
      this.$emit("getPersonFromUserList")
    },
    selectUserAction(person) {
      this.$emit('getPersonFromUserList', person)
    },
    loadMore () {
      if(!this.noMoreData) {
        this.loadData()
      }
	  },
  }
}
</script>

<style scoped>
.page{
  font-size: 0.28rem;
  background-color: white;
  margin-bottom: -0.5rem;
}
.topLayout{
  position: absolute;
  width: 100%;
  top: 0;
}
.userListLayout{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  margin-top: 100px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.navLayout{
  display: flex;
  width: 100%;
  background-color: white;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
  justify-content: center;
}
.navLayout .titleLayout{
  display: inline-block;
  margin: auto calc(50% - 50px);
  margin-left: calc(50% - 50px);
  width: 100px;
  font-size: 14px;
  text-align: center;
}
.navLayout button{
  position: absolute;
  right: 20px;
  border: none;
  font-size: 26px;
  font-weight: lighter;
  top: 6px;
  color: gray;
}
.personCellLayout{
  display: flex;
  width: 100%;
  height: 60px;
  background-color: white;
}
.personCellLayout .personCellPortrait{
  position: relative;
  display: block;
  width: 40px;
  height: 40px;
  margin: auto 12px;
  margin-right: 2px;
  border-radius: 50%;
  object-fit: cover;
  background-color: lightgray;
}
.personCellLayout img{
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background-color: lightgray;
}
.personCellLayout .personNameLayout{
  position: relative;
  float: left;
  text-align: left;
  justify-content: center;
  width: 60%;
  margin: auto 2px; 
  vertical-align: middle;
  padding-left: 2px;
  padding-right: 16px;
  height: max-content;
}
.personCellLayout .personNameLayout p{
  display: block;
  margin: auto 8px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis; 
  overflow: hidden;
}
.personCellLayout .personSelectedLayout{
  float: right;
  position: relative;
  text-align: right;
  vertical-align: middle;
  margin: 16px auto;
}
.personCellLayout .personSelectedLayout button{
  height: 30px;
  width: 60px;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 6px;
  padding: 4px 12px;
}
.singleLineLayout{
  width: 100%;
  height: 1px;
  background-color: #f6f6f6;
}
.loadMoreButtonLayout{
  padding: 10px;
  font-size: 14px;
  color: #888;
  text-align: center;
}
</style>
